import { Component, EventEmitter, HostBinding, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FileInfo } from '../../uploader.interface';

@Component({
  selector: 'glxy-uploader-list',
  templateUrl: './uploader-list.component.html',
  styleUrls: ['./uploader-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GalaxyUploaderListComponent {
  @HostBinding('class') class = 'glxy-uploader-list';

  @Input() files: FileInfo[] = [];

  @Output() fileDeleted: EventEmitter<FileInfo> = new EventEmitter();

  /**
   * Emits the file to delete, when the delete button of an entry is selected
   *
   * @param fileInfo - The file to delete from the file list
   */
  deleteFile(fileInfo: FileInfo): void {
    this.fileDeleted.emit(fileInfo);
  }
}
